import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appFormatSsn]',
  standalone: false
})
export class FormatSsnNumberDirective {
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInputChange(event: Event): void {
    const input = this.el.nativeElement as HTMLInputElement;
    let value = input.value.replace(/[^0-9a-zA-Z]/g, ''); // remove non-digits

    if (value.length > 9) {
      value = value.substring(0, 9); // SSN max = 9 digits
    }

    // Apply XXX-XX-XXXX format
    if (value.length > 5) {
      value = `${value.substring(0, 3)}-${value.substring(3, 5)}-${value.substring(5)}`;
    } else if (value.length > 3) {
      value = `${value.substring(0, 3)}-${value.substring(3)}`;
    }

    input.value = value.toUpperCase();
  }
}
